import Backbone from 'backbone';
import _ from 'underscore';
import { appendLearnMoreLink } from '@bingads-webui-component-legacy/help/index';
import tmpl from '@bingads-webui-campaign-legacy/auto-targets/template/create/index.pug';
import CategoryView from '@bingads-webui-campaign-legacy/auto-targets/view/category-targets/category-grid';
import SpecificTargetView from '@bingads-webui-campaign-legacy/auto-targets/view/create/specificWebPageWithPreview';
import AllWebpageTargetView from '@bingads-webui-campaign-legacy/auto-targets/view/create/all-webpage';
import SelectedTargetsView from '@bingads-webui-campaign-legacy/auto-targets/view/create/selectedTargets';
import RadioGroupView from '@bingads-webui-campaign-legacy/auto-targets/view/create/radiogroup';
import CustomeLabelView from '@bingads-webui-campaign-legacy/auto-targets/view/create/custom-label';
import { PillControl } from '@bingads-webui/pill-control';
import config from '@bingads-webui-component-legacy/config/index';
import MixedSpecificWebPageView from '@bingads-webui-campaign-legacy/auto-targets/view/create/mixedSpecificWebPage';

const i18n = window.globalLegacyI18n.get('component/i18n/loader!campaignui/feature/auto-targets');

export default class View extends Backbone.View {
  initialize(options = {}) {
    if (options.perfMarker) {
      this.perfMarker = options.perfMarker.createChild('Show_DSA_Targets_View');
      this.perfMarker.willInit();
    }
    this.options = _.defaults(options, {
      updateDomain: (domainName) => {
        this.$('.domain-name').text(domainName);
      },
      showHeader: false,
      setting: {},
      shouldCheckArgumentOperandFormat: true,
      hideWebsiteLabel: false,
    });
    this.changes = [];
    this.isViewHidden = options.isViewHidden;
    const permissions = config.get('Permissions');

    this.urlEqualsEnabled = permissions && permissions.dynamic && permissions.dynamic.DSAUrlEquals;
  }
  render() {
    if (this.perfMarker) {
      this.perfMarker.willRender();
    }
    const { DomainName: domainName } = this.options.setting;

    this.$el.html(tmpl({
      appendLearnMoreLink,
      i18n,
      domainName,
      showHeader: this.options.showHeader,
      showPillControl: this.urlEqualsEnabled,
      hideWebsiteLabel: this.options.hideWebsiteLabel,
    }));

    if (this.urlEqualsEnabled) {
      this.targetSwitcher = new PillControl({
        items: [{
          value: 'exacturls',
          text: i18n.get('DSA_AutoTargets_Editor_Exact_URLs'),
          tabPanelId: 'auto-target-exacturls-panel',
        }, {
          value: 'specificpage',
          text: i18n.get('DSA_AutoTargets_Editor_Rules'),
          tabPanelId: 'auto-target-rules-panel',
        }],
        el: this.$('.pill-control'),
      }).render();
    }

    this.selectedTargetsView = new SelectedTargetsView({
      el: this.$('.selected-targets-container'),
      defaultBid: this.options.defaultBid,
      isForVNext: this.options.isForVNext,
      activityLogger: this.options.activityLogger,
      isNegativeAutoTarget: this.options.isNegativeAutoTarget,
    }).render();

    this.viewSelection = [
      {
        name: 'category',
        instance: new CategoryView({
          setting: this.options.setting,
          selectedItems: this.selectedTargetsView.viewmodel.items,
          el: this.$('.category-container'),
          isContainerHidden: this.isViewHidden,
        }).render(),
      },
      {
        name: 'allwebpage',
        instance: new AllWebpageTargetView({
          el: this.$('.allwebpage-container'),
        }).render(),
      },
      {
        name: this.urlEqualsEnabled ? 'mixedspecificwebpage' : 'specificpage',
        instance: this.urlEqualsEnabled ? new MixedSpecificWebPageView({
          setting: this.options.setting,
          el: this.$('.mixedspecificwebpage-container'),
          shouldCheckArgumentOperandFormat: this.options.shouldCheckArgumentOperandFormat,
          isShowUrlOnly: this.options.isShowUrlOnly,
          isExclude: this.options.isExclude,
        }).render() : new SpecificTargetView({
          setting: this.options.setting,
          el: this.$('.specificwebpage-container'),
          shouldCheckArgumentOperandFormat: this.options.shouldCheckArgumentOperandFormat,
          isShowUrlOnly: this.options.isShowUrlOnly,
        }).render(),
      },
      {
        name: 'customlabel',
        instance: new CustomeLabelView({
          setting: this.options.setting,
          el: this.$('.autotarget-customlabel-container'),
          shouldCheckArgumentOperandFormat: this.options.shouldCheckArgumentOperandFormat,
        }).render(),
      },
    ];

    if (this.urlEqualsEnabled) {
      this.targetSwitcher.on('select', (target) => {
        _.each(this.viewSelection, (view) => {
          view.instance.trigger('update:selecttarget', target.item.value);
        });
      });
    }

    this.selectedTargetsView.on('update:values', (values) => {
      const isValidate = this.validate();

      this.trigger('update:value', {
        values,
        isValidate,
      });
      if (_.isFunction(this.options.onChange)) {
        this.options.onChange(this.getChanges(), isValidate);
      }
    });

    _.each(this.viewSelection, (view) => {
      view.instance.on({
        'selectTarget': (target) => {
          if (this.urlEqualsEnabled && view.name === 'mixedspecificwebpage' && target.type === 'exacturls') {
            const uniqueConditions = _.uniq(target.conditions);
            const conditions = [];

            _.each( uniqueConditions, (condition) => {
              conditions.push({
                type: target.type,
                conditions: [condition],
                shouldCheckArgumentOperandFormat: target.shouldCheckArgumentOperandFormat,
              });
            });
            this.selectedTargetsView.viewmodel.addBatch(conditions);
          } else {
            if (_.indexOf(_.invoke(target.conditions, 'validate'), false) >= 0) {
              return; // do not accept any invalid condition
            }

            this.selectedTargetsView.viewmodel.add(target);
          }

          if (this.urlEqualsEnabled && view.name === 'mixedspecificwebpage' && target.type !== 'exacturls') {
            // Reset specific target view
            view.instance.reset(target.type);
          } else if (view.name === 'specificpage' || view.name === 'customlabel') {
            view.instance.reset();
          }
        },
        'categoryLoaded': (isCategoriesEmpty) => {
          if (isCategoriesEmpty) {
            if (this.radiogroup.viewmodel.selectedItem() === 'category') {
              if (this.options.activityLogger) {
                this.options.activityLogger.signal('categories are empty ', 'auto targets');
              }
              this.radiogroup.viewmodel.selectedItem('allwebpage');
            }
            this.radiogroup.viewmodel.disabledItems('category');
          } else {
            this.radiogroup.viewmodel.disabledItems('');
            this.radiogroup.viewmodel.selectedItem('category');
          }
          if (this.perfMarker) {
            this.perfMarker.done();
          }
        },
      });
    });

    this.selectedTargetsView.on('update:items', (items) => {
      _.each(this.viewSelection, (view) => {
        view.instance.trigger('update:items', items);
      });
    });

    this.radiogroup = new RadioGroupView({
      el: this.$('.target-type-radiogroup'),
      setting: this.options.setting,
      selectedItem: this.options.selectedItem,
    }).render();

    if (this.options.hideViewSelection) {
      this.radiogroup.$el.hide();
    }

    this.radiogroup.on('change:radiogroup', () => {
      this.selectedTargetsView.viewmodel.clear();
    });

    this.radiogroup.viewmodel.selectedItem.subscribe((selectedType) => {
      this.toggleView(selectedType);
    });

    if (this.options.selectedItem) {
      this.radiogroup.viewmodel.selectedItem(this.options.selectedItem);
    } else if (this.options.setting && !this.options.setting.DomainName) {
      this.radiogroup.viewmodel.selectedItem('allwebpage');
      this.radiogroup.viewmodel.disabledItems('category');
      this.toggleView('allwebpage');
    } else {
      this.radiogroup.viewmodel.selectedItem('category');
    }

    this.radiogroup.viewmodel.selectedItem.subscribe((value) => {
      if (this.options.activityLogger) {
        this.options.activityLogger.signal(`ad target option change: ${value}`, 'auto targets');
      }
    });

    this.on('update:setting', (setting, shouldReserveSelectedItems) => {
      const selectedItems = this.selectedTargetsView.viewmodel.items();

      _.each(this.viewSelection, (view) => {
        view.instance.trigger('update:setting', setting);
      });

      this.options.updateDomain(setting.DomainName);
      this.radiogroup.trigger('update:setting', setting);

      if (shouldReserveSelectedItems) {
        this.selectedTargetsView.viewmodel.items(selectedItems);
      }
    });

    this.on('update:bid', (bid) => {
      this.selectedTargetsView.viewmodel.adGroupBid(bid);
    });

    this.on('errors', (errors) => {
      this.selectedTargetsView.setErrors(errors);
    });

    return this;
  }

  toggleView(selectedType) {
    _.each(this.viewSelection, (view) => {
      if (view.name === selectedType) {
        view.instance.show();
      } else {
        view.instance.hide();
      }
    });

    // Show targetSwitcher for specific target
    if (this.urlEqualsEnabled) {
      if (selectedType === 'mixedspecificwebpage') {
        this.targetSwitcher.$el.show();
      } else {
        this.targetSwitcher.$el.hide();
      }
    }
  }

  validate() {
    const isValid =  this.selectedTargetsView.validate();

    if (!isValid && this.options.activityLogger) {
      this.options.activityLogger.signal('auto target is not valid', 'auto targets');
    }

    return isValid;
  }

  getChanges() {
    return this.selectedTargetsView.getChanges();
  }

  getValues(adgroupName, campaignName) {
    return {
      DsaTargets: _.map(this.getChanges(), (target) => {
        return _.extend(target, {
          AdGroupName: adgroupName,
          CampaignName: campaignName,
        });
      }),
    };
  }

  updateViewModels(targets) {
    this.selectedTargetsView.updateViewModels(targets);
  }

  hasChanges() {
    return this.selectedTargetsView.viewmodel.hasChanges;
  }
}
